/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caseloading1Inputs */

const en_caseloading1 = /** @type {(inputs: Caseloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const pt_caseloading1 = /** @type {(inputs: Caseloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Caseloading1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const caseloading1 = /** @type {((inputs?: Caseloading1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caseloading1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_caseloading1(inputs)
	return pt_caseloading1(inputs)
});
export { caseloading1 as "caseLoading" }